import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { CommunicationsMethod, MyAccountClient, User } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { ConfigurationSettings } from 'src/app/configuration-settings';

@Component({
    selector: 'app-communication-methods',
    templateUrl: './communication-methods.component.html',
    styleUrls: ['./communication-methods.component.css'],
    standalone: false
})
export class CommunicationMethodsComponent implements OnInit, OnDestroy {
  showSpinner: boolean = false;  
  unsubscribeLink: string = ConfigurationSettings.appLink + '/unsubscribe';  
  policyLink: string = ConfigurationSettings.appLink + '/Policies';  
  termsandconditions: string = ConfigurationSettings.appLink + '/TermConidtions';
  constructor(
    private formBuilder: UntypedFormBuilder,    
    private commonServices: CommonServices,
    private myAccountClient: MyAccountClient,
    private commonService: CommonService,
   private customServices:CustomServiceService) { }

  form: UntypedFormGroup;
  loggedUser: User;
  subscription!: Subscription;
  communicationMethod: CommunicationsMethod;

  ngOnInit(): void {
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetForm();
    this.getCommunicationMethod();
  }
 
  getCommunicationMethod() {
    this.showSpinner = true;
    this.subscription = this.commonService.communicationMethods.subscribe(response => {
      if (response !== null) {
        this.setCellNumber(response.phone);
        this.setEmail(response.email ?? this.loggedUser.emailId);
        this.setCellNumConcent(response.phoneNumberConcent);
        this.setTextConsent(response.textConcent);
        this.communicationMethod = response;
        this.form.controls["Email"].disable();
      }
      this.setEmail(this.loggedUser.emailId);
      this.showSpinner = false;
    });
  }

  GetForm() {
    this.form = this.formBuilder.group({
      CellNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      Email: ['', [Validators.required, Validators.email]],
      TextConsent: ['false'],
      CellNumConcent: ['false']
    });
  }


  get getCellNumber() {
    return this.form.controls["CellNumber"].value;
  }
  get getEmail() {
    return this.form.controls["Email"].value;
  }
  get getTextConsent() {
    return this.form.controls["TextConsent"].value;
  }
  get getCellNumConcent() {
    return this.form.controls["CellNumConcent"].value;
  }

  setCellNumber(cellNumber) {
    return this.form.controls["CellNumber"].setValue(cellNumber);
  }
  setEmail(email) {
    return this.form.controls["Email"].setValue(email);
  }
  setTextConsent(textConsent) {
    if(textConsent === true || textConsent === 'true')
     this.form.controls["TextConsent"].setValue('true');
    else
     this.form.controls["TextConsent"].setValue('false');
  }
  setCellNumConcent(cellConstent) { 
    if(cellConstent === true || cellConstent === 'true')
     this.form.controls["CellNumConcent"].setValue('true');
    else
     this.form.controls["CellNumConcent"].setValue('false');
  }

  getCommunicationObject() {
    var communicationMethodobj = new CommunicationsMethod();
    if (this.communicationMethod !== undefined) {
      communicationMethodobj.id = this.communicationMethod.id;
    }
    communicationMethodobj.phone = this.getCellNumber;
    communicationMethodobj.email = this.getEmail;
    communicationMethodobj.phoneNumberConcent = this.getCellNumConcent;
    communicationMethodobj.textConcent = this.getTextConsent;
    communicationMethodobj.userId = this.loggedUser.id;
    communicationMethodobj.isActive = true;

    return communicationMethodobj;
  }

  SaveCommunicationMethod() {
    if (this.form.controls.CellNumber.errors?.required) {
      this.commonServices.showMessage('error', 'Cell number is required.', 5);
      return;
    }
    if (this.form.controls.CellNumber.errors?.minlength) {
      this.commonServices.showMessage('error', 'Allowed length is 10 digits (without country code).', 5);
      return;
    } 
    if (this.form.controls.CellNumber.errors?.maxlength) {
      this.commonServices.showMessage('error', 'Allowed length is 10 digits (without country code).', 5);
      return;
    }
    if (this.form.controls.Email.errors?.email) {
      this.commonServices.showMessage('error', 'Email Validity check failed, Contact Admin.', 5);
      return;
    }
    if (this.form.valid && !this.form.errors) {
      const updateApi = this.myAccountClient.updateCommnunicationMethod(this.getCommunicationObject());
      const addApi = this.myAccountClient.saveCommunicationMethod(this.getCommunicationObject());
      const api: any = (this.communicationMethod !== undefined) ? updateApi : addApi;
      api.subscribe(response => {
        if (this.communicationMethod !== undefined) {
          if (response ===  true) {
            console.log(this.getCommunicationObject());
            this.commonService.setCommunicationMethods(this.getCommunicationObject());
            this.commonServices.showMessage('success', 'Communication methods saved successfully.', 5);
          } else {
            this.commonServices.showMessage('error', 'Error found wile updating communication methods', 5);
          }
        } else {
          this.commonService.setCommunicationMethods(response);
          this.commonServices.showMessage('success', 'Communication methods saved successfully.', 5);
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onlyNumbersAllowed(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only numbers allowed.', 2);
    }
  }
}
